import { z } from 'zod';

// Mirrors the BFF's EmailStr + 254-character cap.
export const shareTemplateEmailSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, 'Sláðu inn netfang.')
    .max(254, 'Netfangið er of langt.')
    .pipe(z.email('Ógilt netfang.')),
});

export type ShareTemplateEmailFormValues = z.infer<typeof shareTemplateEmailSchema>;

export interface ShareTemplateEmailFormProps {
  templateId: number;
}
